import { useSearchParams } from "react-router-dom"
import { AnalysisSection, type AnalysisView } from "@/components/AnalysisSection"
import { GoNoGoSection } from "@/components/strategy/GoNoGoSection"
import { BidSubNav } from "@/components/bid-menu/BidSubNav"
import { QUALIFY_VIEWS, SUB_VIEW_PARAM, parseSubView } from "@/lib/bid-sections"

/** The existing analysis views, including the submission checklist. */
const QUALIFY_ANALYSIS_VIEWS: AnalysisView[] = [
  "tender_overview",
  "compliance_matrix",
  "submission_checklist",
  "evaluation_criteria",
  "key_dates",
  "risk_register",
]

interface QualifySectionProps {
  bidId: string
  readOnly: boolean
}

/**
 * Qualify: the tender analysis views plus Go/no-go, under one underline
 * sub-nav. The views are today's components, unchanged; `?view=addendum-review`
 * still opens the addendum review surface (no sub-nav item is current then).
 */
export function QualifySection({ bidId, readOnly }: QualifySectionProps) {
  const [searchParams] = useSearchParams()
  const raw = searchParams.get(SUB_VIEW_PARAM)
  const isReviewSurface = raw === "addendum-review"
  const view = parseSubView(QUALIFY_VIEWS, raw)

  return (
    <div className="flex h-full flex-col">
      <BidSubNav label="Qualify" views={QUALIFY_VIEWS} active={isReviewSurface ? null : view} />
      <div className="min-h-0 flex-1 overflow-auto px-6 py-4">
        {view === "go-no-go" && !isReviewSurface ? (
          <GoNoGoSection key={bidId} bidId={bidId} readOnly={readOnly} />
        ) : (
          <AnalysisSection
            bidId={bidId}
            readOnly={readOnly}
            views={QUALIFY_ANALYSIS_VIEWS}
            defaultView="tender_overview"
            hideSubTabs
          />
        )}
      </div>
    </div>
  )
}
